import React, { useEffect } from 'react';

import style from './spinner.module.css';

export const Spinner = (props) => {

    return (
        <div className={`${style.contianer}`}>
            <div id={style.spinner}></div>
        </div>
    )
}
